import { Link } from 'react-router-dom';
import { Heart, EnvelopeSimple } from '@phosphor-icons/react';

export default function Footer() {
  return (
    <footer className="border-t border-[rgba(255,255,255,0.08)] mt-auto" data-testid="footer">
      <div className="max-w-6xl mx-auto px-4 py-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-2">
            <Heart weight="fill" size={20} className="text-[#D4AF37]" />
            <span className="text-lg font-bold font-['Outfit'] text-white">
              Yu<span className="text-gold-gradient">Blink</span>
            </span>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-6 text-sm text-[#9EABCE]">
            <Link to="/legal/impressum" className="hover:text-[#D4AF37] transition-colors" data-testid="footer-impressum">
              Legal Notice
            </Link>
            <Link to="/legal/datenschutz" className="hover:text-[#D4AF37] transition-colors" data-testid="footer-datenschutz">
              Privacy (GDPR)
            </Link>
            <Link to="/legal/agb" className="hover:text-[#D4AF37] transition-colors" data-testid="footer-agb">
              Terms
            </Link>
            <Link to="/feedback" className="hover:text-[#D4AF37] transition-colors flex items-center gap-1" data-testid="footer-feedback">
              <EnvelopeSimple weight="light" size={16} />
              Support
            </Link>
          </div>

          <p className="text-xs text-[#9EABCE]/60">
            &copy; {new Date().getFullYear()} YuBlink. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
